import { useMemo } from 'react';
import styled from 'styled-components';
import { Dropdown } from '../../Dropdown';
import { DropdownContentContainer } from '../../DropdownContentContainer';
import { NumberInput } from '../../baseInputs/NumberInput';
import { useScene } from '../../../../context/sceneContext';

export const PaddingInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData(
    { padding: undefined, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 },
    'props.class'
  );

  const mainInputValue = useMemo(
    () =>
      data.paddingTop === data.paddingBottom &&
      data.paddingBottom === data.paddingLeft &&
      data.paddingLeft === data.paddingRight
        ? data.paddingTop
        : undefined,
    [data]
  );

  return (
    <Row>
      <NumberInput
        iconClassName="icon-padding"
        id={'padding-input'}
        tooltip="Padding"
        value={mainInputValue}
        onChange={(newValue) =>
          scene.updateSelectedElementsData(
            {
              padding: undefined,
              paddingTop: newValue,
              paddingBottom: newValue,
              paddingLeft: newValue,
              paddingRight: newValue,
            },
            'props.class',
            'paddingInput'
          )
        }
        precision={0}
        minValue={0}
        defaultUnit="px"
        inputStyle={{ textAlign: 'center', paddingRight: '16px' }}
        placeholder="mixed"
      />
      <Dropdown
        trigger={
          <DropdownButton>
            <i className="icon-triple-dots" />
          </DropdownButton>
        }
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          width: '16px',
          height: '100%',
        }}
        horizontalAlign="center"
        closeOnClick={false}
      >
        <DropdownContentContainer>
          <Title>Padding</Title>
          <Row>
            <Icon className="icon-border-all" />
            <Label>All</Label>
            <NumberInput
              value={mainInputValue}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    padding: undefined,
                    paddingTop: newValue,
                    paddingBottom: newValue,
                    paddingLeft: newValue,
                    paddingRight: newValue,
                  },
                  'props.class',
                  'paddingInput'
                )
              }
              precision={0}
              minValue={0}
              defaultUnit="px"
              inputStyle={{ textAlign: 'center' }}
              placeholder="mixed"
            />
          </Row>
          <Row>
            <Icon className="icon-border" style={{ rotate: '180deg' }} />
            <Label>Top</Label>
            <NumberInput
              value={data.paddingTop}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    padding: undefined,
                    paddingTop: newValue,
                  },
                  'props.class',
                  'paddingInput'
                )
              }
              precision={0}
              minValue={0}
              defaultUnit="px"
              inputStyle={{ textAlign: 'center' }}
            />
          </Row>
          <Row>
            <Icon className="icon-border" />
            <Label>Bottom</Label>
            <NumberInput
              value={data.paddingBottom}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    padding: undefined,
                    paddingBottom: newValue,
                  },
                  'props.class',
                  'paddingInput'
                )
              }
              precision={0}
              minValue={0}
              defaultUnit="px"
              inputStyle={{ textAlign: 'center' }}
            />
          </Row>
          <Row>
            <Icon className="icon-border" style={{ rotate: '90deg' }} />
            <Label>Left</Label>
            <NumberInput
              value={data.paddingLeft}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    padding: undefined,
                    paddingLeft: newValue,
                  },
                  'props.class',
                  'paddingInput'
                )
              }
              precision={0}
              minValue={0}
              defaultUnit="px"
              inputStyle={{ textAlign: 'center' }}
            />
          </Row>
          <Row>
            <Icon className="icon-border" style={{ rotate: '-90deg' }} />
            <Label>Right</Label>
            <NumberInput
              value={data.paddingRight}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    padding: undefined,
                    paddingRight: newValue,
                  },
                  'props.class',
                  'paddingInput'
                )
              }
              precision={0}
              minValue={0}
              defaultUnit="px"
              inputStyle={{ textAlign: 'center' }}
            />
          </Row>
        </DropdownContentContainer>
      </Dropdown>
    </Row>
  );
};

const Row = styled.div`
  position: relative;
  width: 100%;
  display: flex;

  gap: 5px;
`;

const DropdownButton = styled.div`
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 5px;

  & > i {
    rotate: 90deg;
    font-size: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  transition:
    background-color 0.2s,
    color 0.2s;
  &:hover {
    background-color: var(--neutral-3);
    color: var(--main-1);
  }
`;

const Icon = styled.i`
  font-size: 15px;
  width: 22px;
  height: 22px;

  display: flex;
  justify-content: center;
  align-items: center;
`;
const Label = styled.div`
  width: 100px;
  heigth: 22px;

  font-size: 11px;
  display: flex;
  align-items: center;
`;

const Title = styled.div`
  text-align: center;
  font-size: 12px;
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid var(--neutral-3);
`;
